var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWave7 = function SvgWave7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    d: "M1440 0v68.5C1316 0 280.5 25 0 68.5V0z"
  })));
};
export default SvgWave7;